import AskAssistantButton from './AskAssistantButton.vue';

export default AskAssistantButton;
